import { ExceptionCode, FinanceType, LoadingStatusType, PaymentFlowType, TypeComponentNoti } from "@/enums/enums";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class FetchData extends VuexModule {
  public fetchDataTotalLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public numberOfFetchDataTotal = 0;

  get getFetchDataTotalLoadingStatus(): LoadingStatusType {
    return this.fetchDataTotalLoadingStatus;
  }
  get getNumberOfFetchDataTotal(): number {
    return this.numberOfFetchDataTotal;
  }

  @Mutation
  public SetFetchDataTotalLoadingStatus(status: LoadingStatusType) {
    return (this.fetchDataTotalLoadingStatus = status);
  }
  @Mutation
  public SetNumberOfFetchDataTotal(number: number) {
    this.numberOfFetchDataTotal += number;
  }
  @Mutation
  public ResetNumberOfFetchDataTotal() {
    this.numberOfFetchDataTotal = 0;
  }

  @Action
  public async DoFetchDataTotal(input: any) {
    if (this.fetchDataTotalLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataTotalLoadingStatus", LoadingStatusType.Loading);
      let numberOfFetchDataTotal = 0;
      const messageError = [];
      const messageDataNotFound = [];
      if (input.isCheckWht) {
        const prepareInput = {
          language: i18n.locale,
          paymentFlowType: PaymentFlowType.CashOut,
          fromDate: input.fromDate,
          toDate: input.toDate,
          isExceptItemFiled: input.isExceptItemFiled,
        };
        const responseFetchWht = await API.WithholdingService.DoFetchDataWht(prepareInput);
        if (responseFetchWht.data.responseCode.IsSuccess()) {
          if (responseFetchWht.data.data && responseFetchWht.data.data.length > 0) {
            numberOfFetchDataTotal += responseFetchWht.data.data.length;
          } else {
            messageDataNotFound.push(i18n.t("Fetch_Data_Not_Found", { name: i18n.t("WHT") }));
          }
        } else {
          messageError.push(i18n.t("Fetch_Data_Fail", { name: i18n.t("WHT") }));
        }
      }
      if (input.isCheckSales) {
        const prepareInput = {
          financeType: FinanceType.InFlow,
          fromDate: input.fromDate,
          toDate: input.toDate,
          isExceptItemFiled: input.isExceptItemFiled,
        };
        const responseFetchSalesItem = await API.PP30Service.DoFetchDataPP30Transaction(prepareInput);
        if (responseFetchSalesItem.data.responseCode.IsSuccess()) {
          if (responseFetchSalesItem.data.data && responseFetchSalesItem.data.data.length > 0) {
            numberOfFetchDataTotal += responseFetchSalesItem.data.data.length;
          } else {
            messageDataNotFound.push(i18n.t("Fetch_Data_Not_Found", { name: i18n.t("Sales_Tax_Lowercase") }));
          }
        } else {
          messageError.push(i18n.t("Fetch_Data_Fail", { name: i18n.t("Sales_Tax_Lowercase") }));
        }
      }
      if (input.isCheckPurchase) {
        const prepareInput = {
          financeType: FinanceType.OutFlow,
          fromDate: input.fromDate,
          toDate: input.toDate,
          isExceptItemFiled: input.isExceptItemFiled,
        };
        const responseFetchPurchaseItem = await API.PP30Service.DoFetchDataPP30Transaction(prepareInput);
        if (responseFetchPurchaseItem.data.responseCode.IsSuccess()) {
          if (responseFetchPurchaseItem.data.data && responseFetchPurchaseItem.data.data.length > 0) {
            numberOfFetchDataTotal += responseFetchPurchaseItem.data.data.length;
          } else {
            messageDataNotFound.push(i18n.t("Fetch_Data_Not_Found", { name: i18n.t("Purchase_Tax_Lowercase") }));
          }
        } else {
          messageError.push(i18n.t("Fetch_Data_Fail", { name: i18n.t("Purchase_Tax_Lowercase") }));
        }
      }

      if (numberOfFetchDataTotal > 0) {
        this.context.commit("SetNumberOfFetchDataTotal", numberOfFetchDataTotal);
      }
      if (messageError && messageError.length > 0) {
        messageError.forEach((message) => {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: message,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        });
      }
      if (messageDataNotFound && messageDataNotFound.length > 0) {
        messageDataNotFound.forEach((message) => {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: message,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        });
      }

      this.context.commit("SetFetchDataTotalLoadingStatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    }
  }
}
